import { WithRef } from '../../../types';
import IconBase, { CastProductIconProps, getStrokeWidth } from '../IconBase';

const DEFAULT_PRESET_BACKGROUND = '#EFCC63';

export const CastAIEnabler = ({
  ref,
  variant,
  color = 'currentColor',
  ...props
}: WithRef<SVGSVGElement, CastProductIconProps>) => {
  const strokeWidth = props.strokeWidth ?? getStrokeWidth(props.weight);
  const isPreset = variant === 'preset';
  const fill = isPreset
    ? props.fill ?? DEFAULT_PRESET_BACKGROUND
    : props.fill ?? 'none';

  return (
    <IconBase
      ref={ref}
      {...props}
      color={color}
      viewBox="0 0 25 27"
      fill="none"
    >
      <path
        d="M24.2295 18.6685V8.33154C24.2295 7.20265 23.6272 6.15723 22.6474 5.59279L13.6958 0.423335C12.7179 -0.141112 11.5115 -0.141112 10.5337 0.423335L1.58204 5.59279C0.6042 6.15723 0 7.20265 0 8.33154V18.6685C0 19.7974 0.602213 20.8428 1.58204 21.4072L10.5337 26.5767C11.5115 27.1411 12.7179 27.1411 13.6958 26.5767L22.6474 21.4072C23.6252 20.8428 24.2295 19.7974 24.2295 18.6685Z"
        fill={fill}
      />
      <mask
        id="mask0_18456_2878"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="25"
        height="27"
      >
        <path
          d="M24.2295 18.6685V8.33154C24.2295 7.20265 23.6272 6.15723 22.6474 5.59279L13.6958 0.423335C12.7179 -0.141112 11.5115 -0.141112 10.5337 0.423335L1.58204 5.59279C0.6042 6.15723 0 7.20265 0 8.33154V18.6685C0 19.7974 0.602213 20.8428 1.58204 21.4072L10.5337 26.5767C11.5115 27.1411 12.7179 27.1411 13.6958 26.5767L22.6474 21.4072C23.6252 20.8428 24.2295 19.7974 24.2295 18.6685Z"
          fill={color}
        />
      </mask>
      <g mask="url(#mask0_18456_2878)">
        <path
          d="M12 14L3 23"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeMiterlimit="10"
        />
        <path
          d="M3.27734 13.5011H12.1137V22.3375"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeMiterlimit="10"
        />
        <path
          d="M10.0867 11.472L5.86523 7.25256"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeMiterlimit="10"
        />
        <path
          d="M12.1143 10.6308V4.66235"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeMiterlimit="10"
        />
        <path
          d="M14.1436 11.472L18.363 7.25256"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeMiterlimit="10"
        />
        <path
          d="M14.9819 13.5011H20.9504"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeMiterlimit="10"
        />
      </g>
    </IconBase>
  );
};

CastAIEnabler.displayName = 'CastAIEnabler';
